/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { IChallengeTranslation } from '../challenge-translation-schema';
import { challengeTranslationSchema } from '../challenge-translation-schema';

export const createChallengeTranslationResponseSchema = createApiResponseSchema(
  challengeTranslationSchema,
) as import('zod').ZodSchema<IAPI<IChallengeTranslation>>;

export type ICreateChallengeTranslationResponse = IAPI<IChallengeTranslation>;
